import React, { useEffect, useState } from "react"
import { useUserContext } from "../../userContext"
import { Table, Button, Spin } from "antd"
import type { ColumnsType } from 'antd/lib/table';
import { LoadingOutlined } from '@ant-design/icons';
import { ProgressBar, Status } from './../inventory/InvetoryTableUtils';
import { useNavigate } from 'react-router-dom'
import { getBPTable } from "./../../api/BPTable/BPTableMethods"
import { IBox, DataType } from "../interface/interface"
import SelectOLPN from "./SelectOLPN";
import "./home.css"

const defaultBox: IBox = {
  ON_GOING: true,
  PENDING: true,
  COMPLETE: false,
  TO_DO: true,
}

const defaultSlider: [number, number] = [0, 10000]

const BPTable = () => {
  const [bpData, setBpData] = useState<any>(undefined)
  const [loading, setLoading] = useState<boolean>(false)
  const [selectedBp, setSelectedBp] = useState<DataType | undefined>(undefined)
  const [isOpen, setOpen] = useState<boolean>(false)
  const { user } = useUserContext()
  var navigate = useNavigate()

  useEffect(() => {
    async function getData() {
      setLoading(true)
      const res = await getBPTable(defaultBox, defaultSlider, undefined, undefined)
      if (res?.status && res?.status === 403) {
        setLoading(false)
      } else if (res === "ERR_NETWORK") {
        setLoading(false)
        setBpData([])
      } else {
        setBpData(res)
        setLoading(false)
      }
    }
    getData()
  }, [])

  const columns: ColumnsType<DataType> = [
    {
      title: 'N° BP',
      dataIndex: 'bpNumber',
      key: 'text',
      render: text => <span className='bold-text'>{text}</span>,
    },
    {
      title: "SKU",
      dataIndex: "sku",
      key: "SKU",
      render: text => <span className="bold-text">{text}</span>,
    },
    {
      title: "Progression",
      dataIndex: 'progression',
      key: 'progression',
      render: (elem, record) => <ProgressBar percentage={Math.floor(elem[0] / elem[1] * 100)} progress={elem[0]} max={elem[1]} status={record.status} />,
      width: 300
    },
    {
      title: "Statut",
      dataIndex: 'status',
      key: 'status',
      render: (status) => <Status status={status} />,
      width: 200
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      width: 300,
      render: (_text, record) => (
        <>
          {user && user.group === 'admin' ?
            <Button key={"edit-button-" + record.bpNumber} id={"edit-button-" + record.bpNumber} className='action-button'
              onClick={() => { handleButton(record) }}>{"Editer"}</Button>
            :
            <Button key={"edit-button-" + record.bpNumber} id={"edit-button-" + record.bpNumber} className='action-button'
              onClick={() => { handleButton(record) }}>{"Lancer le controle"}</Button>
          }
        </>
      ),
    }
  ];


  const handleButton = (record: DataType) => {
    setOpen(true);
    setSelectedBp(record)
    if (user?.group === "admin")
      navigate('/edit/' + record.bpNumber + "/" + record.sku, { state: record })
  }

  return (
    <div style={{ overflow: "auto" }}>
      <SelectOLPN bp={selectedBp} setOpen={setOpen} isOpen={isOpen} />
      <div>
        <h2 className='global-view-title'>Suivi BP</h2>
        <Spin spinning={loading} indicator={<LoadingOutlined />}>
          <Table id="bp-table"
            rowKey={(record) => record.bpNumber}
            columns={columns}
            dataSource={bpData ? bpData : undefined} pagination={{
              total: bpData ? bpData.length : 0,
              pageSize: 10,
              itemRender(_page, type, element) {
                if (type === 'prev') return <Button className='rounded-button'>Précédent</Button>
                if (type === 'next') return <Button className='rounded-button'>Suivant</Button>
                return element
              },
            }}
          />
        </Spin>
      </div>
    </div>
  )
}

export default BPTable